export const sebData = {
  name: 'Sebastián Arteaga López',
  title: 'Systems Engineer | Team Lead IT Support',
  location: 'Medellín, Antioquia, Colombia',
  bio: 'Systems Engineer with over 3 years of experience in the technology and operational support sector, specialized in comprehensive IT service management. Strong track record leading and developing technical teams, currently managing 12 people. Experience focused on quality control (QA), metrics administration (SLAs, KPIs), and incident management using ITIL methodologies. Demonstrated ability to drive performance, align infrastructure with strategic objectives, and ensure continuous improvement.',
  email: 'sebastian4798@gmail.com',
  phone: '+57 301 426 5846',
  social: {
    linkedin: 'https://linkedin.com/in/sebastian-arteaga-lopez',
  },
  experience: [
    {
      id: '1',
      company: 'UPS Support',
      role: 'Team Lead Help Desk Support - Senior GBS Customer Care Support',
      duration: 'Apr 2025 - Present',
      description: 'Leading daily operations and direct management of 12 Help Desk and Back Office representatives. Conducting performance evaluations and Quality Review (1:1) sessions. Executing audits, managing tickets (SOP compliance), and optimizing KPIs and SLAs. Leading Major Incidents and advanced technical support (Troubleshooting).',
    },
    {
      id: '2',
      company: 'UPS',
      role: 'Help Desk Support Representative',
      duration: 'Aug 2021 - Apr 2025',
      description: 'Managing incidents in ServiceNow and Salesforce. Administering access (MFA) via MS Azure and Active Directory. Configuring VPN, remote control, and managing mobile devices (BYOD) through MS Intune. Providing comprehensive support for Office 365 and corporate applications.',
    },
    {
      id: '3',
      company: 'AMOLCA Editorial',
      role: 'Digital Analyst',
      duration: 'May 2021 - Aug 2021',
      description: 'Managing HubSpot CRM (workflows, databases) and Email Marketing (A/B testing, metrics). Providing technical support and managing web portal.',
    },
  ],
  education: [
    {
      id: '1',
      degree: 'Systems Engineering',
      institution: 'Universidad Cooperativa de Colombia',
      duration: '2015-2020',
    },
    {
      id: '2',
      degree: 'Specialization in Security and Databases',
      institution: 'SENA',
      duration: '2018-2019',
    },
  ],
  certifications: [
    { id: '1', name: 'Google Cloud Fundamentals', year: '2024' },
    { id: '2', name: 'Scrum Foundation', year: '2021' },
    { id: '3', name: 'Software Testing - SENA', year: '2020' },
  ],
  skills: [
    {
      category: 'Management & Methodologies',
      items: ['ITIL', 'SLA/KPI Management', 'Workforce Management (WFM)', 'Quality Assurance (QA)', 'Scrum'],
    },
    {
      category: 'ITSM & CRM Platforms',
      items: ['ServiceNow', 'Salesforce', 'HubSpot'],
    },
    {
      category: 'Infrastructure & Cloud',
      items: ['Active Directory', 'MS Azure', 'MS Intune', 'Office 365', 'Networks/VPN', 'AWS', 'GCP'],
    },
    {
      category: 'Operating Systems & Development',
      items: ['Windows', 'Linux', 'macOS', 'Python', 'JavaScript', 'HTML', 'CSS', 'MCP-AI'],
    },
    {
      category: 'Languages',
      items: ['Spanish (Native)', 'English (B1 - Intermediate)'],
    },
  ],
};
